import React, { useEffect } from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import DbnpRegistriesComponent from './dbnp-registries.component';
import DBNPProxyOrgRegistries from '../containers/dbnp-proxy-org-registries';
import DBNPOrgRegistryMappings from './dbnp-org-registry-mappings';
import { useSearchParams } from 'react-router-dom';
import DBNPAgentsMappings from './dbn-agents-mappings';




export const DBNRegistryDetails = ({ handlePopulateOrgRegistry,
    id, handleBacicInnerFormChange, handleInnerFormChange, dbnpname, opsnumber, subDomains, domains, countries, back, handleFormSubmit, selectedDbnpRegistry 
  }: any) => {
 const [selectedTabIndex, setSelectedTabIndex] = React.useState<number | null>(null);
      const [searchParams, setSearchParams] = useSearchParams();
  const tabItems = [
    {
      id: 1,
      title: `DBNP Registry Details`,
      component:  <DbnpRegistriesComponent
      handleInnerFormChange={handleInnerFormChange}
      handleBacicInnerFormChange={handleBacicInnerFormChange}
      selectedDbnpRegistry={selectedDbnpRegistry}
      back={back}
      handleFormSubmit={handleFormSubmit}
      id={id}
      dbnpname={dbnpname}
      opsnumber={opsnumber}
      domains={domains}
      subDomains={subDomains}
      countries={countries}
  />,
      isVisible: true,
    },
    
    {
      id: 2,
      title: 'Org Registries',
      component: (
          <DBNPProxyOrgRegistries selectedDbnpRegistry={selectedDbnpRegistry} />
      ),
      isVisible: !!selectedDbnpRegistry?.DBNPId, 
  },

  {
    id: 3,
    title: 'Global Org Registry Mappings',
    component: (
        <DBNPOrgRegistryMappings selectedDbnpRegistry={selectedDbnpRegistry} />
    ),
    isVisible: !!selectedDbnpRegistry?.DBNPId, 
},

{
  id: 4,
  title: 'Global DBN Agents Mappings',
  component: (
      <DBNPAgentsMappings selectedDbnpRegistry={selectedDbnpRegistry} />
  ),
  isVisible: !!selectedDbnpRegistry?.DBNPId, 
},
    
  ];

useEffect(() => {
            const tabTitleFromURL = searchParams.get('tab');
            if (tabTitleFromURL) {
                const tabIndex = tabItems.findIndex(tab => tab.title === tabTitleFromURL);
                if (tabIndex !== -1) {
                    setSelectedTabIndex(tabIndex);
                }
            } else {
                setSelectedTabIndex(0);
            }
        }, [searchParams]);
    
        const handleTabChange = (index: number) => {
            setSelectedTabIndex(index);
            setSearchParams({ tab: tabItems[index].title });
        };
    
        if (selectedTabIndex === null) {
            return null;
        }
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
        {/* {!selectedDbnpRegistry?.IsProxyNetwork &&
         <div className='flex w-full justify-end items-end'>
      <button
            onClick={handlePopulateOrgRegistry}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
           >
            Publish to cloud
           </button>
      </div>}
      {selectedDbnpRegistry?.IsProxyNetwork && (
  <div className="flex w-full justify-end items-end">
    <button
      disabled
      onClick={handlePopulateOrgRegistry}
      type="button"
      className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 relative cursor-not-allowed"
    >
      Publish to cloud
     
    </button>
  </div>
)} */}
      <TabContainer tabItems={tabItems}   selectedIndex={selectedTabIndex}
            onChange={handleTabChange}  />
      <div className='flex w-full justify-end items-end'>
      <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
           >
            Back
           </button>
      </div>
    </div>
  );
};

export default DBNRegistryDetails;
